import React from 'react';
import CardMiddle from '../../../../layouts/Client/CardMiddleItems'
import * as ROUTES from '../../../../routes';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import SignUpInfo from './Cointaners/SignUpInfo'
import SignUpBtns from './Cointaners/SigUpBtns'
import SignUpData from './Cointaners/SignUpData'


const SignUpClient = () => {
  return ( 
    <>
      <CardMiddle 
        mainTitle='Crea tu cuenta' 
        desFooter='¿Ya tienes una cuenta?' 
        footerTitle='Inicia sesión'
        linkTo='/usuario'
      >
        <Switch>
          <Route
            exact
            path={ROUTES.SIGN_UP_CLIENT}
            component={SignUpBtns}
          />
          <Route
            path={ROUTES.SIGN_UP_EMAIL_CLIENT}
            component={SignUpInfo}
          />
          <Route     
            path={ROUTES.SIGN_UP_INFO_CLIENT}
            component={SignUpData}
          />
          <SignUpBtns />    
        </Switch> 
      </CardMiddle>
    </>
  );
}
 
export default SignUpClient;